import { TPagination } from "@custom-types/sorting";
import {
  ContraAccount,
  ContraAccountModel,
} from "@models/contra-account.model";
import { GfhAccount, GfhAccountModel } from "@models/gfh-account.model";
import {
  Participations,
  ParticipationsModel,
} from "@models/participations.model";

import { CostRules, CostRulesModel } from "./cost-rules.model";
import { ExpectedAmount, ExpectedAmountModel } from "./expected-amount.model";
import { PauseReason, PauseReasonModel } from "./pause-reason.model";

export type TExtendedGfhAccountsPaginated = TPagination & {
  data: Array<ExtendedGfhAccount>;
};

export interface ExtendedGfhAccountModel extends GfhAccountModel {
  accountHistoricValuesCount: number;
  contraAccount: string | ContraAccountModel;
  participations: Array<ParticipationsModel>;
  secondaryOwners: Array<any>; // adjust when known
  costRules: Array<CostRulesModel>;
  expectedAmounts: Array<ExpectedAmountModel>;
  reasonsForPaused: Array<PauseReasonModel>;
}

export class ExtendedGfhAccount
  extends GfhAccount
  implements ExtendedGfhAccountModel
{
  accountHistoricValuesCount = -1;
  contraAccount = new ContraAccount();
  participations: Array<Participations> = [];
  secondaryOwners: Array<any> = []; // adjust when known
  costRules: Array<CostRules> = [];
  expectedAmounts: Array<ExpectedAmount> = [];
  reasonsForPaused: Array<PauseReason> = [];

  constructor(dto?: ExtendedGfhAccount) {
    super();
    if (dto) {
      Object.assign(this, dto);
    }
  }
}
